import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, {
    "no-sidebar": true,
    "no-search": true
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "info-text" }, "We have received your request, we will validate and get back to you."),
        _createElementVNode("div", { class: "info-text mt-0" }, [
          _createTextVNode("For any question contact: "),
          _createElementVNode("a", { href: "mailto:list.epx@ciena.com" }, "list.epx@ciena.com")
        ])
      ], -1)
    ]))]),
    _: 1
  }))
}